
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertHeaderGroupLargeIec as ObiAlertHeaderGroupLargeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-header-group-large-iec.js';
 
 
 

 
 export const ObiAlertHeaderGroupLargeIec = createComponent({
   react: React,
   tagName: 'obi-alert-header-group-large-iec',
   elementClass: ObiAlertHeaderGroupLargeIecElement,
   events: {
     
   }
  });
 
 